import { render, staticRenderFns } from "./ExamDashboard.vue?vue&type=template&id=1ad96cfd&scoped=true"
import script from "./ExamDashboard.vue?vue&type=script&lang=js"
export * from "./ExamDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad96cfd",
  null
  
)

export default component.exports